import { Component, OnInit } from '@angular/core';
import { AwsService } from '../../providers/appsyncservice/aws.service';
import * as XLSX from 'xlsx';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { LoginService } from '../../service/login/login.service';
import { AuthService } from '../../guard/auth.service';

@Component({
  selector: 'app-welness',
  templateUrl: './welness.component.html',
  styleUrls: ['./welness.component.css']
})
export class WelnessComponent implements OnInit {

  welnessdata : any;
  reportdata : any;
  nextToken: string = "";
  activePage: 1;
  in_time :string = "";
  to_date :string = "";
  out_time : string = "";
  error : boolean =false;
  wellnessForm : FormGroup;
  searchFlag : boolean =false;
  user_type:string="-1" ;
  constructor(public awserviceProvider: AwsService,private loginService : LoginService,public auth: AuthService) { 
  
    this.loginService.currentType.subscribe(userType => 
      this.user_type=this.auth.getType()
    )
    

}

searchData() {

  if(this.in_time=="" || this.out_time==""){
    this.error=true;
    return;
  }

  let dateFormat = require('dateformat');
  let current = new Date(this.out_time);
  current.setDate(current.getDate() + 1);
  this.to_date = dateFormat(current, "yyyy-mm-dd");

  console.log("in_time",this.in_time)
  console.log("to_date",this.to_date)

   //var sosAll :any[]=[];
   this.nextToken = "";
   this.awserviceProvider.getWelnessData(this.in_time,this.to_date).then(async (res: any) => {
    let data =res.items;
    this.searchFlag=true;
    console.log("this.trips1", res.items)
    if (res.nextToken != null) {
      this.nextToken = res.nextToken; 
      this.searchDataNextToken();
    }
    this.welnessdata =data;
   });
}

migrate(){
  this.awserviceProvider.getWelnessDataMigration().then(async (res: any) => {
  let dateFormat = require('dateformat');
  console.log("this.migrate", res.items)
  let data =res.items;
  data.forEach(element => {
    let now = new Date(element.timestamp);
    let feedback_month = dateFormat(now, "yyyy-mm")
    let feedback_date = dateFormat(now, "yyyy-mm-dd HH:MM:ss")
   
  
     this.awserviceProvider.updateWellnessFeedback(element.id,feedback_month,feedback_date).then(result=>{
       console.log("result",result)
     })
     
   });
  });

}

searchDataNextToken() {
  if (this.nextToken == "" || this.nextToken == null) {
    this.welnessdata = [];
  }
  this.awserviceProvider.getWelnessDataNextToken(this.nextToken,this.in_time,this.to_date).then(async (res: any) => {
    let data =res.items;
    console.log("this.trips2", res.items)
    if (res.nextToken != null) {
      this.nextToken = res.nextToken;
      this.searchDataNextToken();
    }
    this.welnessdata =this.welnessdata.concat(data);
  });
}


jsonFormation(){
  this.reportdata=[];
  this.welnessdata.forEach(element => {
    let data : any={};
    data.rn_number=element.rn_number;
    data.feedback_date = element.feedback_date;
    data.rating =  element.rating;
    data.remarks = element.remarks;
    this.reportdata.push(data);
    
  });
  return this.reportdata;

}

exportToExcel() {
  let exportJsonTemp = [];

  exportJsonTemp = this.jsonFormation();
  const workBook = XLSX.utils.book_new(); // create a new blank book

  const workSheet = XLSX.utils.json_to_sheet(exportJsonTemp);

  // console.log("EXCEL", exportJsonTemp);
  XLSX.utils.book_append_sheet(workBook, workSheet, 'data'); // add the worksheet to the book
  XLSX.writeFile(workBook, 'Wellness App Data.xlsx');


}


  ngOnInit() {
    this.welnessdata=[];
   
  }

}
